/** Figma Group 1321317991 (185:9197) — 628×733 modal frame. */
export const ALL_DELIVERY_COMPLETED_SIZE = {
  width: 628,
  height: 733,
} as const;

export const ALL_DELIVERY_COMPLETED_LAYOUT = {
  titleText: {
    left: 77,
    top: 82,
    width: 474,
    height: 124,
  },
  bodyText: {
    left: 62,
    top: 262,
    width: 504,
    height: 420,
  },
  countdown: {
    left: 62,
    top: 210,
    width: 504,
    height: 48,
  },
} as const;

export const ALL_DELIVERY_COMPLETED_TITLE_ALT =
  'Ого! На сегодня всё доставлено!';

export const ALL_DELIVERY_COMPLETED_BODY_ALT =
  'Жители мира ШУ довольны! Но новые заказы появятся уже завтра! А пока ты можешь накопить лётные билеты и повторить выполненные доставки, чтобы улучшить рейтинг.';
